/* import __COLOCATED_TEMPLATE__ from './code.hbs'; */
import TwoFactorUpgradeCodeComponent from '@square/ember-multipass-components/components/ember-multipass-components/two-factor/upgrade/code';
export default class TwoFactorModalUpgradeCodeComponent extends TwoFactorUpgradeCodeComponent {
  constructor() {
    super(...arguments);
    // Set rememberDevice to false, as the modal does not have an option to remember the device
    this.rememberDevice = false;
  }
}